import { render, staticRenderFns } from "./money-bag.vue?vue&type=template&id=441b8feb&scoped=true&"
import script from "./money-bag.vue?vue&type=script&lang=js&"
export * from "./money-bag.vue?vue&type=script&lang=js&"
import style0 from "./money-bag.vue?vue&type=style&index=0&id=441b8feb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "441b8feb",
  null
  
)

export default component.exports